<template>
    <section id="common_banner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="common_bannner_text">
                        <h2>{{ $t('Hotel details') }}</h2>
                        <ul>
                            <li><router-link to="/">{{ $t('Home') }}</router-link>
                            </li>
                            <li><span><i class="fas fa-circle"></i></span><router-link
                                    to="/hotel-search">{{ $t('Hotel') }}</router-link></li>
                            <li><span><i class="fas fa-circle"></i></span> {{ $t('Hotel details') }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: "HotelDetailBanner"
};
</script>